import React, { useState } from 'react';
import { FormControl, Dropdown, Button } from 'react-bootstrap';
import classnames from 'classnames';
import _ from 'lodash';
import { ReactComponent as GcpLogo } from '../../../../icons/google-cloud-seeklogo.com.svg';
import './index.scss';

const MultipleOrganizations = ({ organizations, setCurrentStepResult, result }) => {
  const [selectedOrganization, setSelectedOrganization] = useState({
    displayName: _.get(result, ['googleOrganization', 'displayName'], 'Select organization'),
    name: _.get(result, ['googleOrganization', 'name'], 'From the list'),
  });

  const handleOrgChange = (organization) => {
    setCurrentStepResult({ googleOrganization: { ...organization } });
    setSelectedOrganization({
      ...organization,
    });
  };

  const matchesOrganizationTextFilter = (filterValue) => (organization) => _.includes(
    _.toLower(JSON.stringify(_.values(_.pick(organization, ['displayName', 'name'])))),
    _.toLower(_.trim(filterValue || '')),
  );

  const OrganizationMediaObject = ({ organization }) => (
    <div className="d-flex gap-6 align-items-center text-truncate">
      <GcpLogo className="org-provider-icon" />
      <div>
        <header>
          {organization.displayName}
        </header>
        <small className="d-block text-muted">{organization.name}</small>
      </div>
    </div>
  );

  const OrganizationSelectorDropdownToggle = React.forwardRef((props, ref) => (
    <div ref={ref} className="d-flex align-items-center gap-4 text-start" aria-haspopup="menu">
      <OrganizationMediaObject organization={selectedOrganization} />
      <div className="text-gray700 ms-auto org-provider-dropdown-icon">
        <i className="bi bi-chevron-down" />
      </div>
    </div>
  ));

  // forwardRef again here!
  // Dropdown needs access to the DOM of the Menu to measure it
  const CustomMenu = React.forwardRef(
    ({ style, className, 'aria-labelledby': labeledBy }, ref) => {
      const [value, setValue] = useState('');
      const filteredOrganizations = _.filter(organizations, matchesOrganizationTextFilter(value));
      const classModifier = classnames(
        'w-100',
        className,
      );

      return (
        <div
          ref={ref}
          style={style}
          role="menu"
          className={classModifier}
          aria-labelledby={labeledBy}
        >
          <div className="px-6 py-4">
            <FormControl
              placeholder="Type to filter..."
              onChange={(e) => setValue(e.target.value)}
              value={value}
            />
          </div>
          <div className="list-group-flush overflow-auto">
            {_.map(filteredOrganizations, (organization) => (
              <Dropdown.Item className="mt-4" key={organization.name} value={organization.displayName} as={Button} onClick={(e) => handleOrgChange(organization)}>
                <OrganizationMediaObject organization={organization} />
              </Dropdown.Item>
            ))}
          </div>
        </div>
      );
    },
  );

  return (
    <div className="account-select container-xxl container-fluid mb-10">
      <Dropdown>
        <Dropdown.Toggle bsPrefix as={Button} variant="outline border" className="overflow-hidden text-truncate org-selector-dropdown-trigger">
          <OrganizationSelectorDropdownToggle />
        </Dropdown.Toggle>
        <Dropdown.Menu as={CustomMenu} className="org-selector-dropdown-menu shadow" />
      </Dropdown>
    </div>
  );
};

export default MultipleOrganizations;
